import { render, staticRenderFns } from "./lojaPerfeitaCriterionQuestionModal.vue?vue&type=template&id=506410a2&scoped=true&"
import script from "./lojaPerfeitaCriterionQuestionModal.vue?vue&type=script&lang=js&"
export * from "./lojaPerfeitaCriterionQuestionModal.vue?vue&type=script&lang=js&"
import style0 from "./lojaPerfeitaCriterionQuestionModal.vue?vue&type=style&index=0&id=506410a2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "506410a2",
  null
  
)

export default component.exports